
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
// import { 
//   OptionalFeatureBase,
// } from "../../../../models";
import { 
  CharacterSubclass,
  CharacterFeatureBase,
  CharacterSpellbook,
  Character,
  GameClass,
  Subclass,
  ExtraSpellLists,
  SubclassFeature
} from "@dndModels";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import { DataType } from "@dndModels/Types";

const char_util = DandDCharacterUtilities.getInstance();

export class CharacterClass extends CharacterFeatureSource {
  position = 0;
  // source_id: string;
  // subclass_id: string;
  source: GameClass | null = null;
  old_char_subclass: CharacterSubclass | null = null;
  // char_feature_bases: CharacterFeatureBase[];
  // subclass_char_feature_bases: CharacterFeatureBase[];
  // level: number = 0;
  subclass_level = 0;
  // do_suggestions: boolean = false;

  get data_type(): DataType {
    return "game_class";
  }

  constructor(obj?: any) {
    super(obj);
    // console.log(obj);
    if (obj) {
      if (this.source_id === "" && obj.game_class_id) {
        this.source_id = obj.game_class_id;
      }
      // this.level = obj.level ? obj.level : 0;
      // this.do_suggestions = obj.do_suggestions ? obj.do_suggestions : false;
      this.position = obj.position ? obj.position : (obj.id ? obj.id : 0);
      this.sub_char_feature_sources = [];
      if (obj.char_subclass) {
        const char_subclass = new CharacterSubclass(obj.char_subclass);
        char_subclass.level = this.level;
        char_subclass.position = this.position;
        char_subclass.game_class_id = this.source_id;
        this.old_char_subclass = char_subclass;
        this.sub_char_feature_sources.push(char_subclass);
      } else if (obj.subclass_id && obj.subclass_id !== "" && obj.subclass_features && obj.subclass_features.length > 0) {
        const char_subclass = new CharacterSubclass();
        char_subclass.level = this.level;
        char_subclass.position = this.position;
        char_subclass.source_id = obj.subclass_id;
        char_subclass.game_class_id = this.source_id;
        for (let i = 0; i < obj.subclass_features.length; ++i) {
          const fb = new CharacterFeatureBase(obj.subclass_features[i]);
          fb.source_id = obj.subclass_id;
          fb.source_type = "subclass";
          fb.source_name = this.name;
          // fb.root_id = obj.subclass_id;
          // fb.root_type = "subclass";
          // fb.root_name = this.name;
          fb.ancestries = [...this.ancestries.map(o => { return {...o}; })];
          char_subclass.char_feature_bases.push(fb);
        }
        this.old_char_subclass = char_subclass;
        this.sub_char_feature_sources.push(char_subclass);
      }
      // this.spellbook = obj && obj.spellbook ? new CharacterSpellbook(obj.spellbook) : null;
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      position: this.position,
      char_subclass: this.char_subclass ? this.char_subclass.toDBObj() : null,
      // level: this.level,
      // do_suggestions: this.do_suggestions,
      // spellbook: this.spellbook ? this.spellbook.toDBObj() : null
    };
  }

  get char_subclass(): CharacterSubclass | null {
    const subclass_finder = this.sub_char_feature_sources.filter(o => o.source_type === "Subclass");

    if (subclass_finder.length === 1) {
      return subclass_finder[0] as CharacterSubclass;
    }
    return null;
  }

  get subclass_id(): string {
    const subclass_finder = this.sub_char_feature_sources.filter(o => o.source_type === "Subclass");

    if (subclass_finder.length === 1) {
      return subclass_finder[0].source_id;
    }
    return "";
  }

  get subclass_variant_group_id(): string {
    const subclass_finder = this.sub_char_feature_sources.filter(o => o.source_type === "Subclass");

    if (subclass_finder.length === 1) {
      return subclass_finder[0].variant_group_id;
    }
    return "";
  }

  get_use_name(): string {
    let use_name = "";
    if (this.replace_name === "") {
      if (this.source) {
        use_name = this.source.true_name;
      }
    } else {
      // console.log(this.replace_name);
      use_name = this.replace_name;
    }
    if (this.subclass) {
      use_name = `${ this.subclass.name } ${ use_name }`;
    }
    const name_bonuses = this.name_bonuses.join(" ");
    return name_bonuses.length > 0 ? name_bonuses + " " + use_name : use_name;
  }

  get subclass(): Subclass | null {
    const subclass_finder = this.sub_char_feature_sources.filter(o => o.source_type === "Subclass");

    if (subclass_finder.length === 1) {
      const char_subclass = subclass_finder[0] as CharacterSubclass;
      return char_subclass.source;
    }
    return null;
  }
  
  // Spellcasting
  get spellcasting_ability() {
    return this.spellcasting.spellcasting_ability;
  }
  get spell_dc() {
    return this.spellcasting.spell_dc;
  }
  get spell_attack() {
    return this.spellcasting.spell_attack;
  }
  get spellcasting_modifier() {
    return this.spellcasting.spellcasting_modifier;
  }
  get spell_table() {
    return this.spellcasting.spell_table;
  }
  get spell_level_max() {
    return this.spellcasting.spell_level_max;
  }
  get spellcasting_level() {
    return this.spellcasting.spellcasting_level;
  }
  // get spellcasting_level_bonus() {
  //   return this.spellcasting.spellcasting_level_bonus;
  // }
  get spell_list_ids() {
    return this.spellcasting.spell_list_ids;
  }
  get schools() {
    return this.spellcasting.schools;
  }
  // get spell_ids(): string[] {
  //   return this.spellcasting.spell_ids;
  // }
  // get cantrip_ids(): string[] {
  //   return this.spellcasting.cantrip_ids;
  // }
  get spells() {
    return this.spellcasting.spells;
  }
  get extra_spells() {
    return this.spellcasting.extra_spells;
  }
  get cantrips() {
    return this.spellcasting.spells.filter(o => o.level === 0);
  }
  get leveled_spells() {
    return this.spellcasting.spells.filter(o => o.level > 0);
  }
  get knowledge_type(): string {
    return this.spellcasting.knowledge_type;
  }
  get cantrips_max(): number {
    return this.spellcasting.cantrips_max + this.spellcasting.extra_cantrips;
  }
  get spells_prepared_max() {
    return this.spellcasting.spells_prepared_max + this.spellcasting.extra_spells_prepared;
  }
  get spell_infusions() {
    return this.spellcasting.spell_infusions;
  }
  get max_infusions_per_item() {
    return this.spellcasting.max_infusions_per_item;
  }
  get ritual_casting(): boolean {
    return this.spellcasting.ritual_casting;
  }
  get spellcasting_focus(): string {
    return this.spellcasting.spellcasting_focus;
  }
  get spellbook(): CharacterSpellbook | null {
    return this.spellcasting.spellbook;
  }
  get bonus_spells() {
    return this.spellcasting.bonus_spells;
  }
  get extra_spell_lists(): ExtraSpellLists[] {
    return this.spellcasting.extra_spell_lists;
  }

  /**
   * This is like copyGameClass, 
   * but it's specifically for the situation where the 
   * character is multiclassed, and they just deleted the
   * first class, and this was the second class.
   * @param game_class 
   */
  fixWithGameClass = (char: Character) => {
    this.char_feature_bases = this.char_feature_bases.filter(fb => fb.feature_base && fb.feature_base.multiclassing === 0);
    if (this.source) {
      this.source.feature_bases.filter(fb => fb.level <= this.level && fb.multiclassing === 1).forEach(fb => {
        const char_feature_base = new CharacterFeatureBase();
        char_feature_base.copyFeatureBase(fb, this, char);
        this.char_feature_bases.push(char_feature_base);
      });
    }
    // if (this.char_subclass && this.subclass) {
    //   this.char_subclass.char_feature_bases = this.char_subclass.char_feature_bases.filter(fb => fb.feature_base && fb.feature_base.multiclassing === 0);
    //   this.subclass.feature_bases.filter(fb => fb.level <= this.level && fb.multiclassing === 1).forEach(fb => {
    //     const char_feature_base = new CharacterFeatureBase();
    //     char_feature_base.copyFeatureBase(fb, this, char, all_feature_sources);
    //     if (this.char_subclass) {
    //       this.char_subclass.char_feature_bases.push(char_feature_base);
    //     }
    //   });
    // }
  }

  connect_subclass = async (char: Character, 
    subclass: Subclass) => {
    let subclass_finder = this.sub_char_feature_sources.filter(o => o.source_type === "Subclass");
    const subclass_cfb_finder = this.char_feature_bases.filter(o => 
      // (o.edition_id === "Any" || char.character_options.edition_id === "Any" || o.edition_id === char.character_options.edition_id) && 
      o.features.filter(o2 => o2.feature_type === "Subclass" && o2.floating_feature instanceof SubclassFeature && o2.floating_feature.level === 1).length > 0);

    if (subclass_finder.length === 1 && subclass_cfb_finder.length === 1) {
      const subclass_cfb = subclass_cfb_finder[0];
      const subclass_cf = subclass_cfb.features.filter(o => o.feature_type === "Subclass")[0];

      if (!(subclass_finder[0] instanceof CharacterSubclass)) {
        const csc = new CharacterSubclass(subclass_finder[0]);
        this.sub_char_feature_sources = this.sub_char_feature_sources.filter(o => o.source_type !== "Subclass");
        this.sub_char_feature_sources.push(csc);
        subclass_finder = this.sub_char_feature_sources.filter(o => o.source_type === "Subclass");
      }
      const char_subclass = subclass_finder[0] as CharacterSubclass;
      // const ancestries: Ancestry[] = [];
      // ancestries.push({ true_id: this.true_id, source_id: this.source_id, parent_id: "", type: "game_class", name: this.name });

      await char_subclass.copy_source({ char, feature_source: subclass, parent_cf: subclass_cf, parent_cfb: subclass_cfb });
      subclass_cf.feature_options = [char_subclass];
    }
  }

  clone(drop_ids = false): CharacterClass {
    const clone = new CharacterClass();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterClass, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.position = copyMe.position;
    this.source = copyMe.source;
  }
}